import { tss } from 'tss-react/mui';

import type { TypeAttributes } from '@/types/common';

const useStyles = tss
  .withParams<{
    color?: TypeAttributes.Status | 'error';
    chipContent?: string;
  }>()
  .create(({ theme, color, chipContent }) => ({
    chip: {
      backgroundColor: chipContent?.includes('-') ? '#E8F5E9' : '#FECDD2',
      borderRadius: 6,
      color: chipContent?.includes('-') ? '#1B5E20' : '#8C0000',
      marginRight: theme.spacing(2)
    },
    smallCardContentSecondary: {
      color: color
        ? theme.vars.palette.text.contrast_a75
        : theme.vars.palette.text.primary_a50,
      fontSize: '0.8vw',
      marginLeft: theme.spacing(0.5),
      lineHeight: 1
    },
    smallCard: {
      backgroundImage: color
        ? 'linear-gradient(to bottom right, transparent, rgba(0, 0, 0, 0.4) 99%)'
        : 'none',
      backgroundColor: color
        ? `var(--mui-palette-${color}-main)`
        : theme.vars.palette.background.elevation1,
      height: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
      containerType: 'inline-size'
    },
    smallCardHeader: {
      color: color
        ? theme.vars.palette.text.contrast
        : theme.vars.palette.text.secondary,
      '& .MuiCardHeader-title': {
        fontSize: '0.8rem',
        '@container (min-width: 200px) and (max-width: 275px)': {
          fontSize: '0.65rem'
        }
      }
    },
    smallCardContent: {
      marginLeft: theme.spacing(2),
      marginBottom: theme.spacing(2),
      padding: '0!important',
      position: 'relative',
      fontWeight: 'bold',
      fontSize: '1.5rem',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      height: '100%',
      svg: {
        maxWidth: '70%'
      },
      [theme.breakpoints.down('xl')]: {
        flexWrap: 'wrap'
      }
    },
    smallCardContentContainer: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-end'
    },
    smallCardContentPrimary: {
      fontWeight: 'bold',
      fontSize: '1.3vw',
      color: color
        ? theme.vars.palette.text.contrast
        : theme.vars.palette.text.primary,
      lineHeight: 1,
      [theme.breakpoints.down('xl')]: {
        fontSize: '1.2vw'
      },
      [theme.breakpoints.down('lg')]: {
        fontSize: '2vw',
        lineHeight: 0.9
      }
    },
    tooltip: {
      color: theme.vars.palette.text.primary_a50,
      marginBottom: -10
    },
    tooltipContainer: {
      position: 'absolute',
      bottom: -5,
      right: 2
    }
  }));

export default useStyles;
